import { render, staticRenderFns } from "./AutomationTitle.vue?vue&type=template&id=08840c3a"
import script from "./AutomationTitle.vue?vue&type=script&lang=js"
export * from "./AutomationTitle.vue?vue&type=script&lang=js"
import style0 from "./AutomationTitle.vue?vue&type=style&index=0&id=08840c3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports